export default __webpack_public_path__ + "static/media/Acessibilidade 4.2d758fb3.svg";